module.exports = __webpack_public_path__ + "img/rope-cleaning-mbfc-tower-1.d9431d0b.jpg";